import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Events/hooks/useEventTypes.ts
/**
* Get list of EventTypes.
*
* @param args
* @param opts
*/
function useEventTypes(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Events.GetEventTypesList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useEventTypes };

//# sourceMappingURL=useEventTypes.js.map